import Ajax from '../js/common/ajax';

export default {
  listPolicySets(params) {
    return Ajax.get('/api/accounting-policy/sets', params);
  },

  getPolicySet(id) {
    return Ajax.get(`/api/accounting-policy/sets/${id}`);
  },

  createPolicySet(data) {
    return Ajax.post('/api/accounting-policy/sets', data);
  },

  updatePolicySet(id, data) {
    return Ajax.put(`/api/accounting-policy/sets/${id}`, data);
  },

  publishPolicy(id, data) {
    return Ajax.post(`/api/accounting-policy/sets/${id}/publish`, data || {});
  },

  archivePolicy(id, data) {
    return Ajax.post(`/api/accounting-policy/sets/${id}/archive`, data || {});
  },

  listRules(policySetId) {
    return Ajax.get(`/api/accounting-policy/sets/${policySetId}/rules`);
  },

  createRule(policySetId, data) {
    return Ajax.post(`/api/accounting-policy/sets/${policySetId}/rules`, data);
  },

  updateRule(ruleId, data) {
    return Ajax.put(`/api/accounting-policy/rules/${ruleId}`, data);
  },

  enableRule(ruleId) {
    return Ajax.post(`/api/accounting-policy/rules/${ruleId}/enable`);
  },

  disableRule(ruleId) {
    return Ajax.post(`/api/accounting-policy/rules/${ruleId}/disable`);
  },

  listVersions(policySetId) {
    return Ajax.get(`/api/accounting-policy/sets/${policySetId}/versions`);
  },

  listAuditLogs(policySetId) {
    return Ajax.get(`/api/accounting-policy/sets/${policySetId}/audit-logs`);
  },

  simulate(data) {
    return Ajax.post('/api/accounting-policy/simulate', data);
  },

  compare(data) {
    return Ajax.post('/api/accounting-policy/compare', data);
  },

  // Cases
  listCases(params) {
    return Ajax.get('/api/accounting-policy/cases', params);
  },

  createCase(data) {
    return Ajax.post('/api/accounting-policy/cases', data);
  },

  getCase(id) {
    return Ajax.get(`/api/accounting-policy/cases/${id}`);
  },

  updateCase(id, data) {
    return Ajax.put(`/api/accounting-policy/cases/${id}`, data);
  },

  archiveCase(id) {
    return Ajax.post(`/api/accounting-policy/cases/${id}/archive`);
  },

  runSimulate(id) {
    return Ajax.post(`/api/accounting-policy/cases/${id}/run-simulate`);
  },

  runCompare(id) {
    return Ajax.post(`/api/accounting-policy/cases/${id}/run-compare`);
  },

  runCases(policySetId) {
    return Ajax.post(`/api/accounting-policy/sets/${policySetId}/run-cases`);
  },

  listRuns(caseId) {
    return Ajax.get(`/api/accounting-policy/cases/${caseId}/runs`);
  },

  seedCases(policySetId) {
    return Ajax.post(`/api/accounting-policy/sets/${policySetId}/seed-cases`);
  }
};
